import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  CheckboxesQuestionModelTypes,
  CheckboxesResponse,
  CheckboxesSubmitResponse,
  ICheckboxesQuestionModelState,
  ICheckboxesResponseValidation
} from './types'

const CheckboxesQuestionModel: IQuestionModelConstructor<CheckboxesQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<CheckboxesQuestionModelTypes, ICheckboxesQuestionModelState>({
    questionType: QuestionType.CHECKBOXES,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema }: ICheckboxesQuestionModelState) {
  const naAnswerOption = questionSchema.answers.find(answer => answer.na)
  const naAnswer = naAnswerOption
    ? response.find(answerResponse => answerResponse.selected && answerResponse.id === naAnswerOption.id)
    : void 0
  if (naAnswer) {
    const submitResponse: ArrayElementType<CheckboxesSubmitResponse> = { id: naAnswer.id }
    if (naAnswer.comment) {
      submitResponse.c = naAnswer.comment
    }
    return [submitResponse]
  } else {
    return response
      .filter(answerResponse => answerResponse.selected)
      .map(answerResponse => {
        const submitAnswerResponse: ArrayElementType<CheckboxesSubmitResponse> = { id: answerResponse.id }
        if (answerResponse.comment) {
          submitAnswerResponse.c = answerResponse.comment
        }
        return submitAnswerResponse
      })
  }
}

function initState(state: ICheckboxesQuestionModelState): ICheckboxesQuestionModelState {
  state.response = state.questionSchema.answers.map<ArrayElementType<CheckboxesResponse>>(answer => {
    return { id: answer.id, selected: false, disabled: false }
  })
  return state
}

function validateResponse({ response, questionSchema }: ICheckboxesQuestionModelState): ICheckboxesResponseValidation {
  if (!questionSchema.answers.filter(a => !a.hidden).length)
    return {
      valid: true
    }
  const selectedAnswerResponses = response.filter(answerResponse => answerResponse.selected)
  const naList = questionSchema.answers.filter(el => el.na)
  const positiveList = questionSchema.answers.filter(el => !el.na)
  const naChecked = naList.some(item => selectedAnswerResponses.some(el => el.selected && el.id === item.id))
  const listSize = positiveList.length
  const exclusiveAllChecked = positiveList.some(
    item =>
      item.exclusive &&
      item.exclusive.length <= listSize &&
      selectedAnswerResponses.some(el => el.selected && el.id === item.id)
  )
  if (naChecked || exclusiveAllChecked) return { valid: true }

  const oeEmpty = selectedAnswerResponses.some(el => {
    const answer = positiveList.find(item => el.id == item.id)
    return answer && el.selected && 'mandatory' === answer.oe && !el.comment?.trim()
  })

  if (oeEmpty) return { valid: false }

  const total = positiveList.reduce(
    (a: number, item) => (selectedAnswerResponses.some(el => el.selected && el.id === item.id) ? a + 1 : a),
    0
  )

  return {
    valid:
      (!questionSchema.min_choices || questionSchema.min_choices <= total) &&
      (!questionSchema.max_choices || total <= questionSchema.max_choices)
  }
}

export default CheckboxesQuestionModel
